export default class SectorsApi {
  constructor(client, url) {
    this.url = url
    this.client = client
  }

  index(params) {
    return this.client.get(this.url, { params }).then((response) => response.data)
  }
}
